<template>
  <div class="modal-card">
    <header class="modal-card-head has-background-black-ter">
      <p class="modal-card-title has-text-light">
        {{ $t('help.wmsexamples') }}
      </p>
      <button
        @click="closeModal()"
        :title="$t('close')"
        class="delete is-medium">
      </button>
    </header>
    <section class="modal-card-body has-background-dark has-text-light padded">
      <div class="wmsdiv">
        {{this.baseUrl}}?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&<span id="transparency">TRANSPARENT={{this.transparency}}</span>&<span style="white-space:nowrap" id="layer">LAYERS={{this.$store.getters['config'].map.layers.baseLayers[this.layer].layers[0].params.LAYERS}}</span>&TILED=true&<span id="time">TIME={{this.time.join(',')}}</span>&<span id="width">WIDTH={{this.w}}</span>&<span id="height">HEIGHT={{this.h}}</span>&CRS={{this.epsg}}&STYLES=&BBOX={{this.bbox.bbox[0]}}%2C{{this.bbox.bbox[1]}}%2C{{this.bbox.bbox[2]}}%2C{{this.bbox.bbox[3]}}
      </div>
      <hr class="tight-hr">
      <div class="content-div">
        <div class="properties-div" style="position: relative;">
          <b-field label="Transparency">
            <input  v-model="transparency" id="transparency" class="input tight-margin" type="text" placeholder="Transparency">
          </b-field>
          
          <b-field label="Layer">
            <b-dropdown v-model="layer" aria-role="list" class="tight-margin">
              <button id="layer" class="button" type="button" slot="trigger" style="width:295px; justify-content: right;">
                <span>{{ layers[layer].title }}</span>
                <b-icon icon="menu-down"></b-icon>
              </button>
              <b-dropdown-item v-for="(item, key) in layers" :value="key" :key="key" aria-role="listitem">
                {{ item.title }} 
                <span v-if="item.layerType == 'coh6'">{{ $t(item.layerType) }}</span>
                <span v-if="item.layerType == 'coh12'">{{ $t(item.layerType) }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>

          <b-field label="Time">
            <input v-model="time" id="time" class="input tight-margin" type="text" placeholder="Time parameter">
          </b-field>

          <b-field label="Width">
            <input @change="updateHeight()" v-model="w" id="width" class="input tight-margin" type="text" placeholder="Width">
          </b-field>

          <b-field label="Height">
            <input @change="updateWidth()" v-model="h" id="height" class="input tight-margin" type="text" placeholder="Height">
          </b-field>

          <button 
            class="button is-light send-request-button"
            type="button"
            @click="loadImage">
              {{ $t('help.wmsexamples.sendrequest') }}
          </button>
                    
          <b-icon class="icon-area-playground icon-on-load-loading loader-on-send" id="loader" size="is-medium" icon="mdi mdi-loading"></b-icon>
          <b-icon class="icon-area-playground icon-on-load-success" id="loaderSuccess" size="is-medium" icon="mdi mdi-check-circle-outline"></b-icon>
          <b-icon class="icon-area-playground icon-on-load-fail" id="loaderFail" size="is-medium" icon="mdi mdi-alert-octagon-outline"></b-icon>
          
        </div>
        <div id="frameDiv" style="width:100%">
          <div id="imageContainer">
            <canvas id="canvas"></canvas>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import moment from 'moment'
import { getPlaygroundImage, createFullWMSLink } from 'util/helpers'

export default {
  components: {

  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.config.map.layers.baseLayers[this.$store.state.baseLayer].layers[0].url,
      transparency: 'true',
      layer: this.$store.getters['baseLayer'],
      time: this.$store.getters['mapTime'],
      w: window.innerWidth,
      h: window.innerHeight,
      epsg: this.$store.state.config.map.layers.baseLayers[this.$store.state.baseLayer].projection.replace(":", "%3A"),
      bbox: this.$map.getFit(),
      layers: this.filterLayers()
    }
  },
  computed: {
    
  },
  mounted () {
    
  },
  methods: {
    filterLayers () {
      var flayers = this.$store.state.config.map.layers.baseLayers
      for (var property in flayers) {
        if (flayers[property].layerType === 'clear') {
            delete flayers[property]
        }
      }
      return flayers
    },
    closeModal () {
      this.$parent.close()
    },
    createLink () {
      // createFullWMSLink(url, transparency, layer, time, width, height, epsg, bbox)
      return createFullWMSLink(
        this.baseUrl,
        this.transparency,
        this.$store.getters['config'].map.layers.baseLayers[this.layer].layers[0].params.LAYERS,
        this.time,
        this.w,
        this.h,
        this.epsg,
        this.bbox
      )
    },
    loadImage () {
      // Turn on loading icon
      this.switchIcon("loader")

      getPlaygroundImage(this.createLink()).then(response => {
        // Turn off and on corresponding icons
        this.switchIcon("loaderSuccess")

        // Set the image
        let img = "data:image/png;base64, " + response

        // Retreive fractions of the left-upper corner of the image container
        const bodyRect = document.body.getBoundingClientRect()
        const imgContainerRect = document.getElementById('imageContainer').getBoundingClientRect()
        const top_percent = (imgContainerRect.top - bodyRect.top) / bodyRect.height
        const left_percent = (imgContainerRect.left - bodyRect.left) / bodyRect.width
        
        // Create a new clipped image
        var imgc = new Image()
        imgc.onload = function() {
          
          // Get fractions of the "transparent" window
          const height_percent = document.getElementById('imageContainer').offsetHeight / bodyRect.height
          const width_percent = document.getElementById('imageContainer').offsetWidth / bodyRect.width
         
          // Read input image size
          const input_width = imgc.width
          const input_height = imgc.height

          // Set up canvas
          const canvas = document.getElementById('canvas')
          document.getElementById("canvas").setAttribute("width", input_width*width_percent)
          document.getElementById("canvas").setAttribute("height", input_height*height_percent)

          // Get context and draw image
          const ctx = canvas.getContext('2d')
          ctx.drawImage(imgc, input_width*left_percent, input_height*top_percent, input_width*width_percent, input_height*height_percent, 0, 0, input_width*width_percent, input_height*height_percent)
        }
        imgc.src = img
      }).catch(error => {
        this.switchIcon("loaderFail")
        console.log(error)
      })
    },
    switchIcon (id) {
      var icons = ["loader", "loaderSuccess", "loaderFail"]
      var filtered = icons.filter(function(value, index, arr) { 
        return value !== id
      })

      document.getElementById(id).setAttribute("style", "visibility:visible")

      filtered.forEach(function (item, index) {
        document.getElementById(item).setAttribute("style", "visibility:hidden")
      })
    },
    updateHeight () {
      const ratio = window.innerWidth / window.innerHeight
      this.h = Math.round(this.w / ratio)
    },
    updateWidth () {
      const ratio = window.innerWidth / window.innerHeight
      this.w = Math.round(this.h * ratio)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .modal-card-body
    padding: 0px
    position: relative
    height: calc(100vh - 180px)
    overflow: auto
    &.padded
      padding: 20px
    .wmsdiv
      word-break: break-all
  .tight-margin
    margin-top: -8px
  .padded
    padding: 5px
  #transparency
    background: #db8d93
  #layer
    background: #749985
  #time
    background: #82aeb5
  #width
    background: #bdb77d
  #height
    background: #bdb77d
  #imageContainer
    height: 450px 
    max-width: 930px
    overflow: auto
    display: flex
    justify-content: center
    margin: auto 5px auto 5px
    align-items:center
  .content-div
    display: flex
    height: 100%
    max-height: 450px
  .tight-hr
    margin:2px
    height: 1px
  .send-request-button
    position: absolute
    bottom: 5px
    width: 80%
  .icon-area-playground
    position: absolute
    bottom: 7px
    right: 5px
    visibility: hidden
  .icon-on-load-success
    color: #18a553
  .icon-on-load-fail
    color: palevioletred
  .icon-on-load-loading
    visibility: hidden
    color: #f3f3f3
  .loader-on-send
    animation: spin 2s linear infinite
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  @media (min-width: 768px)
    .modal-card
      height: 650px
  @media (min-width: 1200px)
    .modal-card
      width: 1200px
      height: 650px
</style>
